import { FormattedMessage, IntlShape } from 'react-intl';
import { getCountry } from '../../../iwIntlProvider/CountryProvider';
import { LiveChatSVG } from '../../../svgComponents/liveChatSVG/LiveChatSVG';
import { PaymentCardSVG } from '../../../svgComponents/paymentCardSVG/PaymentCardSVG';
import { RocketSVG } from '../../../svgComponents/rocketSVG/RocketSVG';
import {
    FLEXI_LOAN_PRODUCT_TYPE,
    FLEXI_24_PRODUCT_TYPE
} from '../accountsSelector';
import messages from './OutstandingView.messages';
import { TProductType } from '../../dashboard/Dashboard.types';

// eslint-disable-next-line import/no-default-export
export default (
    intl: IntlShape,
    loanDuration: number,
    productType: TProductType
) => [
    [FLEXI_LOAN_PRODUCT_TYPE, FLEXI_24_PRODUCT_TYPE].includes(productType) && {
        title: <FormattedMessage {...messages.faqIncreaseLoanTitle} />,
        description: (
            <FormattedMessage
                tagName="div"
                {...messages.faqIncreaseLoanDescription}
                values={{
                    strong: (chunks) => <strong>{chunks}</strong>,
                    linebreak: <br />,
                    span: (chunks) => (
                        <span data-testid="flexi-faq-months">{chunks}</span>
                    ),
                    months:
                        productType === FLEXI_24_PRODUCT_TYPE
                            ? '24'
                            : loanDuration,
                    percentage:
                        productType === FLEXI_24_PRODUCT_TYPE ? '85' : '70'
                }}
            />
        ),
        readMoreHref:
            getCountry() === 'UK' &&
            'https://support.iwoca.co.uk/en/articles/498744-can-i-top-up-my-loan',
        backgroundIcon: <RocketSVG />
    },
    {
        title: <FormattedMessage {...messages.faqEarlyRepaymentsTitle} />,
        description: (
            <FormattedMessage
                tagName="div"
                {...messages.faqEarlyRepaymentsDescription}
                values={{
                    strong: (chunks) => <strong>{chunks}</strong>,
                    linebreak: <br />
                }}
            />
        ),
        readMoreHref:
            getCountry() === 'UK' &&
            'https://support.iwoca.co.uk/en/articles/592981-how-do-repayments-work ',
        backgroundIcon: <PaymentCardSVG />
    },
    getCountry() === 'UK' && {
        title: "What if I can't repay?",
        description: (
            <>
                If you have trouble repaying, let us know so we can work with
                you to find a solution. We might be able to lower your monthly
                repayments, or move the date you pay them.
                <br />
                <br /> There are lots of different{' '}
                <strong>ways we can help,</strong> so please call us on 020 3397
                3375.
            </>
        ),
        readMoreHref:
            'https://support.iwoca.co.uk/en/articles/1608757-how-we-can-help-if-you-miss-a-payment-or-you-re-struggling-to-repay',
        backgroundIcon: <LiveChatSVG />
    }
];
